import { render, staticRenderFns } from "./RealtimeRiskCia.vue?vue&type=template&id=eb2cf6ee&"
import script from "./RealtimeRiskCia.vue?vue&type=script&lang=js&"
export * from "./RealtimeRiskCia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports